import { MESSAGES } from 'src/modules/common/constants';
import { AirflowEnum, DamperBlades } from 'src/actuators/user-input/types';

export const mapBladeTypeNames = {
    [DamperBlades.ParallelBladeWithSeals]: MESSAGES.ParallelBladeWithSeals,
    [DamperBlades.OpposedBladeWithSeals]: MESSAGES.OpposedBladeWithSeals,
    [DamperBlades.ParallelBladeWithoutSeals]: MESSAGES.ParallelBladeWithoutSeals,
    [DamperBlades.OpposedBladeWithoutSeals]: MESSAGES.OpposedBladeWithoutSeals,
};

export const mapAirflowNames = {
    [AirflowEnum.low]: MESSAGES.AirflowLow,
    [AirflowEnum.mid]: MESSAGES.AirflowMid,
    [AirflowEnum.high]: MESSAGES.AirflowHigh,
};
